<!-- 游戏任务管理 -->
<template>
  <div class='content'>
    <el-form ref="form" label-width="auto" align="left" :inline="true">
      <el-form-item label="所属游戏：">
        <el-select v-model="params.outGameId">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="item in gamesData" :key="item.outGameId" :value="item.outGameId"
            :label="item.gameName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务类型：">
        <el-select v-model="params.taskType">
          <el-option value="" label="全部"></el-option>
          <el-option value="1" label="每日任务"></el-option>
          <el-option value="3" label="自定义任务"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务状态：">
        <el-select v-model="params.status">
          <el-option value="0" label="全部"></el-option>
          <el-option value="1" label="待开始"></el-option>
          <el-option value="2" label="进行中"></el-option>
          <el-option value="3" label="已结束"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="getTableList()">搜索</el-button>
        <el-button size="small" @click="resetParams(); getTableList();">重置</el-button>
        <!-- <el-button size="small" type="primary">导出</el-button> -->
      </el-form-item>
    </el-form>

    <el-table :data="tableData" class="mt-20" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <!-- show-overflow-tooltip -->
      <el-table-column label="所属游戏" prop="gameName"></el-table-column>
      <el-table-column label="任务名称" prop="title"></el-table-column>
      <el-table-column label="任务类型" prop="taskType">
        <template slot-scope="scope">{{ scope.row.taskType == 1 ? "每日任务" : (scope.row.taskType == 2 ? "自定义任务" : "--") }}</template>
      </el-table-column>
      <el-table-column label="奖励名称" prop="prizes"></el-table-column>
      <el-table-column label="奖励份数" prop="limitNum"></el-table-column>
      <el-table-column label="剩余份数" prop="leftCnt"></el-table-column>
      <el-table-column label="开始时间" prop="cycleStart"></el-table-column>
      <el-table-column label="结束时间" prop="cycleEnd"></el-table-column>
      <el-table-column label="排序" prop="taskOrder" width="50">
        <template slot-scope="scope">
          <el-input v-model="scope.row.taskOrder" type="text" size="mini" @blur="handleOrderBlur(scope.row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="任务状态" prop="status">
        <template slot-scope="scope">{{ scope.row.status | statusFilters }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewData(scope.row.taskId)">查看数据</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-row class="mt-15 mr-20 text-right" v-if="total > 0">
      <el-pagination small layout="total,prev,pager, next,sizes,jumper" :page-size="params.pageSize" :total="total"
        :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap';
export default {
  components: { VueUeditorWrap },
  data() {
    //这里存放数据
    return {
      params: {
        outGameId: '',
        taskType: '',
        status: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      tableData: [],
      gamesData: []
    };
  },
  filters: {
    statusFilters(status) {
      switch (status) {
        case 1:
          return '待开始';
        case 2:
          return '进行中';
        case 3:
          return '已结束';
        default:
          break;
      }
    }
  },
  //方法集合
  methods: {
    viewData(taskId) {
      this.$router.push({ path: '/taskDataDetails', query: { taskId } })
    },
    /**获取列表数据 */
    getTableList() {
      this.ajax.fetch({
        url: this.apis.taskRecords.get,
        disableLoading: true,
        method: 'post',
        param: this.params,
        successFunc: res => {
          this.total = res.total;
          this.tableData = res.result;
        },
        errorFunc: err => {
          this.$message.error(err.info);
        }
      });
    },
    handleOrderBlur(row) {
      // 移除首尾空格
      const value = (row.taskOrder || '').trim();

      // 验证是否为数字，不是则清空或设为默认值
      if (!/^\d+$/.test(value)) {
        //恢复没操作前的排序
        row.taskOrder = 1;
        this.$message.warning('请输入数字');
      } else {
        // 转为数字类型
        row.taskOrder = parseInt(value, 10);
        // 调用更新接口
        this.updateTaskOrder(row);
      }
    },
    //更新一行排序
    updateTaskOrder(row) {
      this.ajax.fetch({
        url: this.apis.taskRecords.updateTaskOrder,
        disableLoading: true,
        method: 'post',
        param: {
          taskId: row.taskId,
          recordOrder: row.taskOrder,
          recordId: row.recordId
        },
        successFunc: res => {
          this.$message.success('更新成功');
          this.getTableList();
        },
        errorFunc: err => {
          this.$message.error(err.info);
        }
      });
    },
    resetParams() {
      this.params = {
        outGameId: '',
        taskType: '',
        status: '',
        pageNum: 1,
        pageSize: 10
      }
    },
    handleSizeChange(page) {
      this.params.pageSize = page;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.params.pageNum = val;
      this.getTableList();
    },
          /**获取游戏数据 */
    getGameList(){
      this.ajax.fetch({
        url: this.apis.taskRecords.getOutGameSelected,
        disableLoading: true,
        method: 'post',
        successFunc: res=>{
          this.gamesData = res;
        },
        errorFunc: err=>{
          this.$message.error(err.info);
        }
      });
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getTableList();
    this.getGameList();
  },
}
</script>

<style lang='scss' scoped></style>


// WEBPACK FOOTER //
// src/page/activityManage/taskRecords/taskRecords.vue